import * as React from 'react';
import { useSelector } from 'react-redux';
import { SeoMortgageLink as SeoMortgageLinkComponent } from '../../components/SeoMortgageLink';
import { promosSeoPageUrlSelector, promosSeoPageActiveSelector } from '../../selectors/seoPages';
import { trackClickPromosSeoLink } from '../PromosSection/tracking';

export const SeoPromosLink = () => {
  const url = useSelector(promosSeoPageUrlSelector);
  const isPageActive = useSelector(promosSeoPageActiveSelector);

  const onClick = React.useCallback(() => {
    trackClickPromosSeoLink();
  }, []);

  /* istanbul ignore next */
  if (!isPageActive) {
    return null;
  }

  return <SeoMortgageLinkComponent url={url} onClick={onClick} title="Акции и скидки" testId="seo_promos_link" />;
};
